import { FC } from 'react';
import cn from 'classnames';

import { PriceComponent } from 'components/Shared/SharedComponents';
import { PsychicCardImage } from 'entities/PsychicCardImage';
import { StatusIndicatorWithText, PsychicNameWithIcon } from 'entities/JsxParserComponents';
import { PsychisReadingType } from 'constants/enums';

import styles from './styles.module.scss';

import type { IPsychicPhotoModule } from '../config/declarations';
import { getRatePerMinute } from '../lib';

/* Nested Component */
const CallbackReadingDetail = ({ psychic, psychicSkeleton }) => {
  const { detailsButton } = psychicSkeleton;

  return (
    <div className={styles.details}>
      <p>
        {detailsButton.slug}
        {psychic.estimatedWaitTime}
      </p>
    </div>
  );
};

/* Nested Component */
const ReadingDetails = ({ psychic, psychicSkeleton }) => {
  const { type } = psychic;
  const isCallBack = type === PsychisReadingType.CALLBACK;
  const isAppointment = type === PsychisReadingType.APPOINTMENT;
  const isUpcoming = type === PsychisReadingType.UPCOMING;
  const showColon = isCallBack || isAppointment || isUpcoming;

  if (psychic.considerCtaButtons) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.textPlaceHolder1}>
        <p className={styles.type}>{showColon ? `${type}:` : type}</p>
      </div>
      {isCallBack && (
        <CallbackReadingDetail
          psychic={psychic}
          psychicSkeleton={psychicSkeleton}
        />
      )}
      {(isAppointment || isUpcoming) && (
        <p>{psychic.date.replace(/^0/, '').replace(',', '').replace('PM', 'pm')}</p>
      )}
    </div>
  );
};

/* Main component */
const PhotoWithReadingRateDetails: FC<IPsychicPhotoModule> = ({
  src,
  psychic,
  imageClassName,
  psychicSkeleton,
}) => {
  const rates = getRatePerMinute(psychic);
  const labelIcon = psychicSkeleton?.labelsCollection?.items
    ?.find((item) => item?.slug === 'verification-icon');

  return (
    <div className={styles.photoWithRate}>
      <PsychicCardImage
        psychic={psychicSkeleton}
        image="external"
        src={src}
        alt={psychic.psychicName}
        className={cn(styles.image, imageClassName)}
      />
      <div className={styles.stars}>
        <PsychicNameWithIcon
          psychicName={psychic.psychicName}
          image={labelIcon?.image!}
          wrapperClass={cn(styles.psychicName, styles.name)}
          className={styles.psychicIcon}
        />
      </div>
      <div className={styles.rateStatus}>
        <PriceComponent
          ratePerMinute={rates}
          ratePerMinuteText={psychicSkeleton.ratePerMinute}
        />
        <StatusIndicatorWithText
          chatStatus={psychic.chatStatus}
          phoneStatus={psychic.phoneStatus}
          wrapperClass={styles.status}
        />
      </div>
      <div className={styles.photoWithReadings}>
        <ReadingDetails
          psychic={psychic}
          psychicSkeleton={psychicSkeleton}
        />
      </div>
    </div>
  );
};

export default PhotoWithReadingRateDetails;
